import React from 'react';
import Navbar from '../../components/navbar';
import CRUDCapis from '../../components/crudCapis';

function VistaDatosCapis () {
    return (
        <CRUDCapis />
    )
}

export default VistaDatosCapis;